import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getUserProjectCodes, updateUserProjectCodes} from 'src/openapi/admin/apis/UserProjectCodesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {UpdateProjectCode} from 'src/openapi/admin/models/UpdateProjectCode';

type Props = {
    userId: number,
};

export const useProjectCodes = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getUserProjectCodes({userId}, {signal}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        updateProjectCode: UpdateProjectCode[],
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        updateUserProjectCodes({
            userId,
            updateUserProjectCodesRequest: {projectCodes: updateProjectCode, reason: options?.reason},
        }, {signal}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        initValue: [],
        getDispatchAction,
        saveDispatchAction,
    });
};
